import React, { useState, useEffect } from "react";
import { Typography, Paper, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AccessibilityNewIcon from "@material-ui/icons/AccessibilityNew";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import EditIcon from "@material-ui/icons/Edit";
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import BiztranControls from "../../biztran_controls/BiztranControls";
import ModalFrame from "../../biztran_controls/Modal_Frame";
import CreateLead from "./CreateLead";
import ConvertLead from "./ConvertLead";

const LeadViewHeader = ({ LeadID, LeadMainData, PopulateData }) => {
  const classes = useStyles();
  const [isOpen, setOpen] = useState(false);
  const [isOpenConvert, setOpenConvert] = useState(false);
  const [DisableConvetbtn, setDisableConvetbtn] = useState(false);
  const [LID, setLID] = useState("");
  const [Mode, setMode] = useState("");
  const [ContactName, setContactName] = useState("");
  const [Email, setEmail] = useState("");
  const [Phone, setPhone] = useState("");
  const [Address, setAddress] = useState("");
  const [Company, setCompany] = useState("");
  const [CreatedBy, setCreatedBy] = useState("");
  const [ModifiedBy, setModifiedBy] = useState("");

  const handleOpenModal = () => {
    debugger;
    setMode("Update");
    setLID(LeadID);
    setOpen(true);
  };

  const convertOpenModal = () => {
    setOpenConvert(true);
  }

  // const handleOpenNEWModal = () => {
  //   setOpen(true);
  //   setMode("Insert");
  //   setLID("");
  // };

  useEffect(() => {
    if (LeadMainData !== undefined && LeadMainData.length > 0) {
      // debugger;

      setContactName(LeadMainData[0].ContactName);
      setCompany(LeadMainData[0].CompanyName);
      setPhone(LeadMainData[0].Phone);
      setEmail(LeadMainData[0].Email);
      setAddress(
        LeadMainData[0].Address1 + " " + LeadMainData[0].Address2
      );
      setCreatedBy(LeadMainData[0].CreatedBy);
      setModifiedBy(LeadMainData[0].ModifiedBy);
      if (LeadMainData[0].LeadStatus === "Opportunities") {
        // debugger;
        setDisableConvetbtn(true);
      }
    }
  }, [LeadMainData]);

  return (
    <div>
      <Paper elevation={3}>
        <Typography
          className={classes.headertext}
          noWrap
        >
          <AccessibilityNewIcon style={{ fontSize: 45 }} />
          <div style={{ flexDirection: "column" }}>
            <div style={{ fontSize: 13 }}>Lead</div>
            <div style={{ fontSize: 19, fontWeight: "bold" }}>
              {ContactName}
            </div>
          </div>
          <div style={{ width: "99%" }}>
            <div style={{ float: "right", marginTop: -3 }}>
              {/* <BiztranControls.Button
                text="NEW"
                startIcon={<AddCircleOutlineIcon />}
                style={{ width: "24%" }}
                onClick={() => {
                  handleOpenNEWModal();
                }}
              /> */}
              <BiztranControls.Button
                text="EDIT"
                startIcon={<EditIcon />}
                style={{ width: "24%" }}
                onClick={() => {
                  handleOpenModal();
                }}
              />
              <BiztranControls.Button
                text="CONVERT"
                startIcon={<SwapHorizIcon />}
                disabled={DisableConvetbtn}
                onClick={() => {
                  convertOpenModal();
                }}
              />
            </div>
          </div>
        </Typography>
        <Grid spacing={1} container style={{ marginTop: 7, marginLeft: 3 }}>
          <Grid item xs={12} container direction="row">
            <Grid item xs={2} container direction="row">
              <div style={{ color: "#808080" }}>Company</div>
            </Grid>
            <Grid item xs={2} container direction="row">
              <div style={{ color: "#808080" }}>Address</div>
            </Grid>
            <Grid item xs={2} container direction="row">
              <div style={{ color: "#808080" }}>Phone</div>
            </Grid>
            <Grid item xs={3} container direction="row">
              <div style={{ color: "#808080" }}>Email</div>
            </Grid>
          </Grid>
          <Grid item xs={2} container direction="row">
            <div style={{ color: "#0096FF" }}>{Company}</div>
          </Grid>
          <Grid item xs={2} container direction="row">
            <div style={{ color: "#0096FF" }}>{Address}</div>
          </Grid>
          <Grid item xs={2} container direction="row">
            <div style={{ color: "#0096FF" }}>{Phone}</div>
          </Grid>
          <Grid item xs={3} container direction="row">
            <div style={{ color: "#0096FF" }}>{Email}</div>
          </Grid>
        </Grid>
        <ModalFrame
          title="Lead Details"
          maxWidth="md"
          isOpen={isOpen}
          setOpen={setOpen}
        >
          <CreateLead
            LeadID={LID}
            Mode={Mode}
            setOpen={setOpen}
            PopulateData={PopulateData}
          />
        </ModalFrame>
        <ModalFrame
          title="Convert Lead"
          maxWidth="md"
          isOpen={isOpenConvert}
          setOpen={setOpenConvert}
        >
          <ConvertLead
            setDisableConvetbtn={setDisableConvetbtn}
            setOpenConvert={setOpenConvert}
            LeadID={LeadID}
            LeadData={LeadMainData}
            PopulateData={PopulateData}
          />
        </ModalFrame>
      </Paper>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  header: {
    width: "100%",
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "2.7rem",
    fontSize: "1.8rem",
    marginTop: "4.2rem",
    display: "flex",
    flexDirection: "row",
  },
  headertext: {
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "2.9rem",
    fontSize: "1.8rem",
    marginTop: "4.3rem",
    display: "flex",
    flexDirection: "row",
    //   borderRadius: "1rem",
  },
}));

export default LeadViewHeader;
